module.exports = __webpack_public_path__ + "img/brand_3.14cb9325.png";